import grapesjs from 'grapesjs';
import type {Editor} from 'grapesjs';
import GRAPESJS_CONFIG from './config/grapesjs';

/** Initializes a GrapesJS editor instance with the email-maker plugin pre-installed. */
export function initializeEditor(container: HTMLElement, plugin: (editor: Editor) => void): Editor {
  return grapesjs.init({
    ...GRAPESJS_CONFIG,
    container,
    plugins: [plugin],
  });
}
